import { NotificationListFilter } from '@/api/DTO/notification/notification.interface';
import { PaginationAndSorting } from '@/api/DTO/common.interface';

export enum NotificationReadStatus {
	all = 'all',
	unread = 'unread',
	read = 'read',
}

export interface NotificationSummaryFilter extends PaginationAndSorting {
	searchString: string;
	readStatus: NotificationReadStatus;
}

/**
 * The summary page's form state as the list endpoint wants it.
 *
 * Only the read filter needs translating: it is a tri-state on the wire — `true`
 * read, `false` unread, absent for all — so "all" drops the key rather than sending
 * a value. Everything else is already in request shape and goes over untouched, the
 * way the other summary pages pass their filter straight to their endpoint.
 *
 * `sortings` empty accepts the backend default of newest first, which is the order
 * the REQ asks for. The recipient and branch come from the bearer token, so there is
 * nothing to send for them.
 */
export function notificationListFilter({
	readStatus,
	...filter
}: NotificationSummaryFilter): NotificationListFilter {
	return {
		...filter,
		...(readStatus === NotificationReadStatus.read ? { isRead: true } : {}),
		...(readStatus === NotificationReadStatus.unread ? { isRead: false } : {}),
	};
}
